<script setup lang="ts">
import OfferingsTable from '@/components/OfferingsTable.vue'

definePage({ meta: { requiresAuth: true } })

const route = useRoute('dive-centers-id-offerings-services')
const id = String(route.params.id)
</script>

<template>
  <OfferingsTable
    :dc-id="id"
    kind="service"
  />
</template>
